export default __webpack_public_path__ + "static/media/volkihar-enderal-logo-large.51681375.png";